class Button {
    constructor(elem, submitButtonText) {
        this.button = $(elem);
        let buttonText = 'Loading...';
        if (submitButtonText) {
            buttonText = submitButtonText;
        }
        this.buttonText = buttonText;
        $(this.button).on('click', (e) => {
            if ($(this.button).is(':disabled') || $(this.button).hasClass('disabled')) {
                e.preventDefault();
                return false;
            }
        })
    }
    // Show spiner with loading text
    turnLoadingOn() {
        if (!this.button.data('previous')) {
            let $spinner = $('<span role="status" aria-hidden="true"></span>');
            $spinner.addClass('spinner spinner-border spinner-border-sm');
            this.button.data('previous', this.button.html()).prepend($spinner);
        }

        this.button
            .prop('disabled', true)
            .html(this.buttonText);
        
    }
    turnLoadingOff() {
        this.button.prop('disabled', false).html(this.button.data('previous'));
        $('.spinner', this.button).remove();
    }
    // Show only spinner and hide all text
    showSpinner() {
        if (this.button.find('.spinner-border').length === 0) {
            this.addSpinner();
        }
        $(".spinner-border", this.button).show();
        $(".text", this.button).hide();
        $("body").css("cursor", "progress");
    }
    hideSpinner() {
        $(".spinner-border", this.button).hide();
        $(".text", this.button).show();
        $("body").css("cursor", "default");
    }
    addSpinner() {
        let $flexCenter = $('<div>');
        let $spinner =
            '<div class="spinner-border spinner-border-sm" role="status" style="display:none"></div>';
        $flexCenter.append($spinner);
        this.button
            .wrapInner('<div class="text"></div>')
            .prepend($flexCenter);
    };
}

export default Button;